// @ constants
const actionTypes = require('constants/actionTypes');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;

const hiringProductInformationDataRequest = () => ({
    type: actionTypes.HIRING_PRODUCT_INFORMATION_IS_FETCHING
});

const hiringProductInformationDataFailure = () => ({
    type: actionTypes.HIRING_PRODUCT_INFORMATION_FAILURE
});

const hiringProductInformationDataSuccess = (response) => ({
        type: actionTypes.HIRING_PRODUCT_INFORMATION_SUCCESS,
        payload: {
            response: response,
        }
});

const resetProductInfo = () => {
    return {
        type: actionTypes.HIRING_PRODUCT_INFORMATION_RESET
    };
}

const getHiringProductInformation = (product, uiComponentId) => (dispatch) => {
    const requestData = {
        query : {
            channel: "private",
            lang: getLanguage().toLowerCase(),
            overrideConfiguration: false,
            requestedProducts: product,
            uiComponentId: uiComponentId
        }
    };

    dispatch(hiringProductInformationDataRequest());
    return APIPost({
        dispatch,
        endpoint: 'hiringProductInformation',
        params: requestData
    })
    .then(response => {
        dispatch(hiringProductInformationDataSuccess(response));
    })
    .catch(response => {
        if (response.error) {
            dispatch(hiringProductInformationDataFailure(response.error.description));
        } else {
            dispatch(hiringProductInformationDataFailure(''));
            throw response;
        }
    });
};

module.exports = {
    getHiringProductInformation,
    resetProductInfo
}
